<script>
import { cloneDeep } from "lodash";
import Office from "@/components/modals/delivery-unit.vue";

export default {
  name: "ProcessTypeManageDuModal",
  components: {
    Office,
  },
  data() {
    return {
      tableData: [],
      selectedProcess: null,
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          sortable: true,
          tdClass: "Delivery Unit",
        },
        {
          key: "office",
          sortable: true,
          label: "Office",
          tdClass: "align-middle",
        },
        {
          key: "campus",
          sortable: true,
          label: `${ this.GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office' }`,
          tdClass: "align-middle",
        },
        {
          key: "actions",
          sortable: false,
          label: "Actions",
          tdClass: "align-middle",
          thStyle: { width: "85px" },
        },
      ],
      tableBusy: false,
    };
  },
  computed: {
    rows() {
      if (this.filter) {
        return this.totalRows;
      }
      return this.tableData.length;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getDU(props) {
      this.tableBusy = true;
      this.selectedProcess = null;
      this.selectedProcess = cloneDeep(props);
      this.$store
        .dispatch("dtsprocesstype/GetDUByProcessType", props.id)
        .then((res) => {
          this.tableData = res.data;
          this.totalRows = 1;
          this.currentPage = 1;
          this.perPage = 10;
          this.filter = null;
          this.filterOn = [];
          this.tableBusy = false;
        });
    },
    getOffice() {
      this.$refs.office.getFilteredMultipleData(this.tableData);
      this.$bvModal.show("office-modal");
    },
    dropOffice(data) {
      let ids = [];
      data.forEach((item) => {
        ids.push({
          deliveryUnitId: item.id,
          isProcessOwner: item.isOwner
        });
      });
      this.$store
        .dispatch("dtsprocesstype/AddProcessTypeDU", {
          id: this.selectedProcess.id,
          array: ids,
        })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.forEach((item) => {
            this.tableData.push(item);
          });
          this.showToast("Successfully added!", "success");
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    removeProcessTypeDU(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtsprocesstype/RemoveProcessTypeDU", {
              processTypeId: this.selectedProcess.id,
              deliveryUnitId: props.id,
            })
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var index = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(index, 1);
              this.showToast("Successfully removed", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be removed!", "error");
            });
        }
      });
    },
  },
};
</script>
      
<template>
  <b-modal
    id="modal-processDu"
    title="Manage Delivery Unit Access"
    size="lg"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
  >
    <div class="mt-1">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <div id="tickets-table_filter" class="dataTables_filter">
          <label class="d-inline-flex align-items-center">
            Search:
            <b-form-input
              autocomplete="off"
              v-model="filter"
              type="search"
              placeholder="Search..."
              class="form-control form-control-sm ms-2"
            ></b-form-input>
          </label>
        </div>
        <button
          type="button"
          @click="getOffice()"
          class="btn btn-sm btn-success d-flex align-items-center ms-1"
        >
          <i class="bx bx-plus fs-6 me-1"></i>Add Office
        </button>
      </div>
    </div>
    <div class="table-responsive mb-0">
      <b-table
        class="datatables"
        :items="tableData"
        :fields="fields"
        responsive="sm"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        :busy="tableBusy"
        @filtered="onFiltered"
        bordered
        outlined
        striped
        show-empty
      >
        <template #empty="scope">
          <div class="text-center">{{ scope.emptyText }}</div>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center align-items-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-20px h-20px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #cell(name)="row">
          <div class="align-middle">{{ row.value }}</div>
          <div class="text-success" v-if="row.item.isProcessOwner"><i class="bx bx-check"></i> Process Owner</div>
        </template>
        <template #cell(actions)="row">
          <div class="text-center">
            <a
              href="javascript:void(0);"
              class="text-danger"
              @click="removeProcessTypeDU(row.item)"
              ><i class="bx bx-trash font-size-20 fs-2"></i
            ></a>
          </div>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
    <Office ref="office" @dropMultiple="dropOffice($event)"></Office>
  </b-modal>
</template>